import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  states: {
    stateList: []
  },
  filterList: {
    data: [],
    filterCategoryNames: []
  },
  useCaseList: {
    data: []
  },
  personaList: {
    data: []
  },
  // Computed/transformed filter values
  stateListFilter: [],
  pointOfInterestFilter: [],
  filterListData: []
}

const filterListDetailSlice = createSlice({
  name: 'filterListDetail',
  initialState,
  reducers: {
    setStates: (state, action) => {
      state.states = action.payload
    },
    setFilterList: (state, action) => {
      state.filterList = action.payload
    },
    setUseCaseList: (state, action) => {
      state.useCaseList = action.payload
    },
    setPersonaList: (state, action) => {
      state.personaList = action.payload
    },
    setStateListFilter: (state, action) => {
      state.stateListFilter = action.payload
    },
    setPointOfInterestFilter: (state, action) => {
      state.pointOfInterestFilter = action.payload
    },
    setFilterListData: (state, action) => {
      state.filterListData = action.payload
    }
  }
})

export const {
  setStates,
  setFilterList,
  setUseCaseList,
  setPersonaList,
  setStateListFilter,
  setPointOfInterestFilter,
  setFilterListData
} = filterListDetailSlice.actions

export const selectStates = (state) => state.filterListDetail?.states ?? {stateList: []}
export const selectFilterList = (state) => state.filterListDetail?.filterList ?? {data: [], filterCategoryNames: []}
export const selectUseCaseList = (state) => state.filterListDetail?.useCaseList ?? {data: []}
export const selectPersonaList = (state) => state.filterListDetail?.personaList ?? {data: []}
export const selectStateListFilter = (state) => state.filterListDetail?.stateListFilter ?? []
export const selectPointOfInterestFilter = (state) => state.filterListDetail?.pointOfInterestFilter ?? []
export const selectFilterListData = (state) => state.filterListDetail?.filterListData ?? []

export default filterListDetailSlice.reducer
